import mwrHttp from '@/utils/activityHttp'

// 中秋活动服务地址：开发环境走本地 8999 端口，测试/正式环境走网关服务名。
const isDev = process.env.VUE_APP_ENV === 'dev'
const actHost = isDev
  ? ''
  : String(process.env.VUE_APP_ACT_URL || '').replace(/\/$/, '')

let basePath = isDev
  ? '/minifire-mid-autumn/api/v1'
  : `${actHost}/minifire-mid-autumn/api/v1`

if (process.env.VUE_APP_ENV === 'prod') {
  basePath = `${String(process.env.VUE_APP_ACT_URL || 'https://wapi.miniworldgame.com').replace(/\/$/, '')}/minifire-mid-autumn/api/v1`
}

export default {
  getActivityInfo: (params = {}) => {
    return mwrHttp.post(`${basePath}/mid-autumn/activity-info`, params)
  },

  // 聚合账号查询成功后由活动服记录一次登录。
  getCpUserInfo: (params = {}) => {
    return mwrHttp.post(`${basePath}/mid-autumn/query-cp-user-info`, params)
  },

  // rewardList 成功后由活动服记录登录、充值累计值和当前资格。
  getRewardList: (params = {}) => {
    return mwrHttp.post(`${basePath}/mid-autumn/reward-list`, params)
  },
}
